module.exports = __webpack_public_path__ + "img/12_101.86554dcb.png";